import { Box, Tooltip, Typography, useTheme, alpha, ClickAwayListener, Link } from "@mui/material";
import { ArrowForwardIos } from "@mui/icons-material";
import { FC, useEffect, useState } from "react"
import { useLocation, useNavigate } from "react-router-dom";

import { useActions } from "../../hooks/useActions";
import { useTypedSelector } from "../../hooks/useTypedSelector";

import LinkRouter from "../LinkRouter";
import { IAppBarItem } from "../../containers/DefaultLayout/Header";
import { BoxStyle, TypographyStyle } from "./styled";


interface IProps {
    item: IAppBarItem,
    closeMenu: any
}

const HeaderDroprightMenu: FC<IProps> = ({ item, closeMenu }) => {
    const { palette } = useTheme();
    const location = useLocation();
    const navigate = useNavigate();

    const { GetHeaderProjects } = useActions();
    const { projects, projectsCount } = useTypedSelector((store) => store.announcementUser);

    const [open, setOpen] = useState<boolean>(false)

    let isProjectInList: boolean = false;

    useEffect(() => {
        getData();
    }, [open])

    const getData = async () => {
        try {
            await GetHeaderProjects(true, "", "", 1, 10, null);
        } catch (ex) {
        }
    };

    return (
        <>
            <ClickAwayListener onClickAway={() => setTimeout(() => setOpen(false), 100)} >
                <Tooltip
                    placement="right-start"
                    PopperProps={{
                        disablePortal: true
                    }}
                    onClose={() => setOpen(false)}
                    open={open}
                    disableFocusListener
                    disableHoverListener
                    disableTouchListener
                    componentsProps={{
                        tooltip: {
                            sx: {
                                background: palette.background.default,
                                p: "4px",
                                color: "inherit",
                                borderRadius: "6px",
                                display: open ? "block" : "none",
                                marginLeft: "12px !important",
                                marginTop: "0px !important"
                            },
                        },
                    }}
                    title={
                        <Box sx={{ width: "145px", "&:last-child": { mb: 0 } }} >
                            {projects.map((item, index) => {
                                if (location.pathname === `/projects/${item.urlSlug}` && index !== 7)
                                    isProjectInList = true;

                                if (index < 7)
                                    return (
                                        <Link
                                            key={`header_menu_tooltip_item_${index}`}
                                            underline="none"
                                            color="inherit"
                                            href={`/projects/${item.urlSlug}`}
                                            onClick={() => { setOpen(false); }}
                                        >
                                            <Typography
                                                component="h5"
                                                fontSize="14px"
                                                lineHeight="22px"
                                                fontFamily="Fixel Display, sans-serif"
                                                sx={{
                                                    transition: "background 0.4s ease",
                                                    background: (location.pathname === `/projects/${item.urlSlug}`) ? alpha(palette.primary.light, 0.35) : "transparent",
                                                    '&:hover': {
                                                        background: alpha(palette.primary.light, 0.35),
                                                    },
                                                    borderRadius: "4px",
                                                    p: "7px 13px"
                                                }}
                                                noWrap
                                                onClick={() => { closeMenu() }}
                                            >
                                                {item.title}
                                            </Typography>
                                        </Link>
                                    );
                                else if (index === 7)
                                    return (
                                        <LinkRouter
                                            key={`header_menu_tooltip_item_${index}`}
                                            underline="none"
                                            color="inherit"
                                            to={`/projects`}
                                            onClick={() => { setOpen(false); }}
                                        >
                                            <Typography
                                                component="h5"
                                                fontSize="14px"
                                                lineHeight="22px"
                                                fontFamily="Fixel Display, sans-serif"
                                                sx={{
                                                    transition: "background 0.4s ease",
                                                    background: (!(location.pathname.startsWith(`/projects/`)) || isProjectInList) ? "transparent" : alpha(palette.primary.light, 0.35),
                                                    '&:hover': {
                                                        background: alpha(palette.primary.light, 0.35),
                                                    },
                                                    borderRadius: "4px",
                                                    mb: "4px",
                                                    p: "9px 16px"
                                                }}
                                                noWrap
                                                onClick={() => { closeMenu() }}
                                            >
                                                Показати більше...
                                            </Typography>
                                        </LinkRouter>
                                    )
                            })}
                        </Box>
                    }
                >
                    <BoxStyle
                        open={open}
                        selected={(location.pathname === item.path || location.pathname.startsWith(`${item.path}/`))}
                        onClick={() => { setOpen(!open); }}
                    >
                        <TypographyStyle>
                            {item.lable}
                        </TypographyStyle>
                        <ArrowForwardIos
                            sx={{
                                opacity: open ? 0 : 1,
                                visibility: open ? "hidden" : "visible",
                                transition: "opacity 0.4s ease, visibility 0.4s ease",
                                width: "12px", height: "12px",
                                mr: "12px"
                            }}
                        />
                    </BoxStyle>
                </Tooltip >
            </ClickAwayListener>
        </>
    )
}

export default HeaderDroprightMenu